import { Component } from '@angular/core';
import { columnChartConfig, splineChartConfig } from './configs/chart.config';
import { VlDataService, VlHttpService, HTTPAPIConfig, APIConfigMapping } from 'shared-library';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'lib-web-analytics',
  templateUrl: './web-analytics.component.html',
  styleUrls: ['./web-analytics.component.scss']
})
export class webAnalyticsComponent {

  constructor(
    private dataService: VlDataService,
    private httpService: VlHttpService,private route:ActivatedRoute) { }
    options:any[]=[{
    name:'This Week',
    value:'Week'},{
    name:'This Month',
    value:'Month'},{
    name:'Cumulative',
    value:'Cumulative'}]
    installationsChart : {
      config: any,
      data: any[],
      visibility: {
        renderChart: boolean,
        showChart: boolean
      },
      spinner: boolean
    } = {
        config: this.dataService.deepClone(splineChartConfig),
        data: [],
        visibility: {
          renderChart: true,
          showChart: false
        },
        spinner: true
    }
    userChart : {
      config: any,
      data: any[],
      visibility: {
        renderChart: boolean,
        showChart: boolean
      },
      spinner: boolean
    } = {
        config: this.dataService.deepClone(columnChartConfig),
        data: [],
        visibility: {
          renderChart: true,
          showChart: false
        },
        spinner: true
    }
    submissionsChart : {
      config: any,
      data: any[],
      visibility: {
        renderChart: boolean,
        showChart: boolean
      },
      spinner: boolean
    } = {
        config: this.dataService.deepClone(columnChartConfig),
        data: [],
        visibility: {
          renderChart: true,
          showChart: false
        },
        spinner: true
    }
    apiData:any;
  ngOnInit() {
      //intially set it to Today
      this.getData('Week');
  }

  onToggleChange(_event:any){
   this.getData(_event?.value)
  }
    
  getData(filterValue:any){
    this.installationsChart.visibility.renderChart = false;
    this.submissionsChart.visibility.renderChart = false;
    this.userChart.visibility.renderChart = false;
    this.installationsChart.spinner = true;
    this.submissionsChart.spinner = true;
    this.userChart.spinner = true;
    const apiConfig: HTTPAPIConfig = this.dataService.deepClone(APIConfigMapping['GET_METRICS']);
    const currentParams = { ...this.route.snapshot.queryParams };
    apiConfig.postData = {
      "application_id":currentParams['id'],
      "filter":filterValue
    }
    this.httpService.placeAPICall(apiConfig).subscribe({
      next: (data: any) => {
        this.apiData = data?.result?.total;
        let types = [{name : 'installationsChart', key: 'appInstallations',color:['lightgreen']},{name:'submissionsChart',key:'submissions',color:['blue']},{name:'userChart',key:'users',color:['green']}];
        types.map((type:any) => {
          (this[type['name'] as keyof typeof this] as any).config.colors = [];
          (this[type['name'] as keyof typeof this] as any).config.xAxis.categories = [];
          (this[type['name'] as keyof typeof this] as any).config.series = [];
          (this[type['name'] as keyof typeof this] as any).config.colors = type['color'];
          (this[type['name'] as keyof typeof this] as any).config.xAxis.categories = Object.keys(data?.result[type.key]);
          (this[type['name'] as keyof typeof this] as any).config.series.push({
            name: 'Day',
            data:Object.values(data?.result[type.key])
          })
        })
      },
      complete:() => {
        this.configReset();
      },
      error: (err: any) => {
        this.configReset();
      }
    })
  }
  configReset(){
    this.installationsChart.visibility.renderChart = true;
    this.submissionsChart.visibility.renderChart = true;
    this.userChart.visibility.renderChart = true;
    this.installationsChart.spinner = false;
    this.submissionsChart.spinner = false;
    this.userChart.spinner = false;
  }
}
